'use client'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PlanSummaryCard from './PlanSummaryCard'

export default function PlansSummary({ subscription }: any) {
	return (
		<Stack gap={3}>
			<Typography variant="h4">Plans</Typography>

			{subscription?.plans?.map((plan: any) => <PlanSummaryCard key={plan.id} plan={plan} />)}
		</Stack>
	)
}
